<template>
  <div
    v-show="getLayout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${getDarkMode ? 'bg-transparent' : 'bg-success'}`"
  />
    <aside
      class="
        my-3
        overflow-auto
        border-0
        sidenav
        navbar navbar-vertical navbar-expand-xs
        border-radius-xl
        fixed-start
        ms-3
      "
      :class="`${
        getLayout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${getSidebarType}`"
      id="sidenav-main"
      v-show="getShowSidenav"
      v-click-away="onClickAway"
    >
      <div class="sidenav-header">
        <i
          class="
            top-0
            p-3
            cursor-pointer
            fas
            fa-times
            text-secondary
            opacity-5
            position-absolute
            end-0
            d-none d-xl-none
          "
          aria-hidden="true"
          id="iconSidenav"
        ></i>
        <router-link class="m-0 navbar-brand" to="/" :style="GetBrandCss">
          <img :src="logo" class="navbar-brand-img h-100" alt="main_logo" />
        </router-link>
      </div>
      <hr class="mt-0 horizontal dark" />
      <sidenav-list :cardBg="custom_class" />
    </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logos/r-logo.svg";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      navbarToogler:"<i class=\"sidenav-toggler-line bg-white\"></i>",
    };
  },
  computed: {
    ...mapGetters([
      "getDarkMode",
      "getSidebarType",
      "getShowSidenav",
      "getShowSidebarType",
      "getLayout",
    ]),
    GetBrandCss() {
      return {
        filter:
          this.getDarkMode || this.getSidebarType === "bg-default"
            ? "brightness(2)"
            : "brightness(1)",
      };
    },
  },
  props: ["custom_class", "layout"],
  methods: {
    ...mapMutations(["setShowSidenavMutation", "navbarMinimize"]),
    onClickAway(e) {
      if (e.path[0].outerHTML !== this.navbarToogler) {
        this.setShowSidenavMutation(!this.getShowSidenav);
        this.navbarMinimize();
      }
    },
  },
};
</script>
